import { KameleonBase } from "./kameleon-base";
import { themeColor } from "./theme-helper";

export const Beta: typeof KameleonBase & any = () => ({
  colors: {
    variables: {
      _neutral: "#F7FBF3",
      _mainCTA: "#84B118",
      _secondaryCTA: "#E27700",
      _dark: "#CE1F48",
      _darkest: "#00211A",
      _neutralLight: "#FFFFFF",
    },
    modes: {
      dark: {
        glow: "transparent",
      },
      overlays: {
        linearGradient: `linear-gradient(90deg, ${themeColor(
          "primary"
        )} 0%, ${themeColor("variables._darkest")} 100%)`,
        opacity: themeColor("variables.greys.50"),
      },
    },
    glow: `color-mix(in srgb, ${themeColor(
      "variables._mainCTA"
    )}, transparent 60%)`,
    gradient: "linear-gradient(to right, rgba(255,0,0,0), rgba(255,0,0,1))",
  },
  fontSizes: [
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.25rem",
    "1.5rem",
    "1.75rem",
    "2rem",
    "2.25rem",
    "2.5rem",
    "2.75rem",
    "3rem",
    "3.25rem",
    "3.5rem",
    "3.75rem",
    "4rem",
    "4.5rem",
    "5rem",
    "5.25rem",
    "5.5rem",
    "7.5rem",
    "10rem",
  ],
  lineHeights: {
    body: 1.65,
    heading: 1.125,
  },
  text: {
    large: {
      fontSize: [5, null, 6],
    },
    medium: {
      fontSize: [3, null, 4],
    },
    mediumSmall: {
      fontSize: [2, null, 3],
    },
    small: {
      fontSize: 2,
    },
    tiny: {
      fontSize: 1,
    },
    tagline: {
      color: themeColor("secondary"),
      fontSize: 2,
      fontWeight: "700",
    },
  },
  styles: {
    h1: {
      variant: "text.heading",
      fontSize: [14, null, 15, 16],
      lineHeight: 1.2,
    },
    h2: {
      variant: "text.heading",
      fontSize: [14, null, 15, 16],
      lineHeight: 1.2,
    },
    h3: {
      variant: "text.heading",
      fontSize: [11, null, 13, 14],
      lineHeight: 1.2,
    },
    h4: {
      variant: "text.heading",
      fontSize: [7, null, 8, 9],
      lineHeight: 1.3,
    },
    h5: {
      variant: "text.heading",
      fontSize: [5, null, 6],
      lineHeight: 1.4,
    },
    h6: {
      variant: "text.heading",
      fontSize: [3, null, 4],
      lineHeight: 1.4,
    },
    p: {
      fontSize: 3,
    },
    b: {
      fontSize: 3,
      fontWeight: "bold",
    },
    hr: {
      borderBottom: `1px solid ${themeColor("elements.hr")}`,
      borderRadius: 99999,
    },
  },
  cards: {
    primary: {
      boxShadow: `0 4px 28px ${themeColor("variables.grays.10")}`,
      borderRadius: "24px",
    },
    vertical: {
      content: {
        paddingTop: "2rem",
        paddingBottom: "2rem",
        paddingRight: "2rem",
        "@media screen and (max-width: 767px)": {
          paddingTop: "0",
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
    horizontal: {
      default: {},
      content: {
        paddingLeft: "2rem",
        paddingBottom: "2rem",
        paddingRight: "2rem",
        "@media screen and (max-width: 767px)": {
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
  },
  buttons: {
    primary: {
      borderRadius: "8px",
      boxShadow: `0 10px 24px ${themeColor("glow")}`,
      font: "body",
      fontWeight: 700,
      fontSize: 2,
      padding: "0.75rem 1.75rem",
      "&:hover": {
        boxShadow: "none",
      },
    },
    secondary: {
      color: themeColor("secondary"),
      background: `color-mix(in srgb, ${themeColor(
        "variables._neutralLight"
      )}, transparent 90%)`,
      boxShadow: `inset 0 0 0 1.5px ${themeColor("secondary")}`,
      borderRadius: "8px",
      fontWeight: 700,
      fontSize: 2,
      padding: "0.75rem 1.75rem",
    },
  },
  images: {
    nonBackground: {
      borderRadius: "24px",
    },
    card: {
      horizontal: {
        borderTopLeftRadius: "24px",
        borderTopRightRadius: "24px",
      },
      vertical: {
        borderTopLeftRadius: "24px",
        borderBottomLeftRadius: "24px",
      },
    },
  },
  boxes: {
    footer: {
      borderRadius: "24px",
    },
    slider: {
      boxShadow: "large",
      borderRadius: "24px",
      slide: {
        backgroundColor: themeColor("muted"),
      },
    },
  },
});
